import { InlineIcon } from '@iconify/react';
import { FC, useCallback } from 'react';
import SupplierInfoDialogContent from 'src/components/SupplierInfoDialogContent';
import useConfirm from 'src/hooks/useConfirm';
import { SupplierInfo } from 'src/services/useInvoiceDetailsApi';

interface SupplierInfoProps {
  supplierInfo: SupplierInfo;
}

const SupplierInfoModal: FC<SupplierInfoProps> = ({ supplierInfo }) => {
  const { confirm } = useConfirm();

  const handleClick = useCallback(() => {
    confirm({
      title: 'Supplier Details',
      content: <SupplierInfoDialogContent supplierInfo={supplierInfo} />,
      cancelButtonText: 'Close',
      cancelColor: 'info',
      hasNoConfirmButton: true,
    });
  }, [confirm, supplierInfo]);

  const display = supplierInfo?.companyName ? supplierInfo?.companyName : supplierInfo?.name;

  return (
    <div className="p-1 text-[13px]">
      <p className="font-bold flex items-center pb-1 gap-1">
        Supplier
        <span title={'View More'}>
          <InlineIcon
            icon="mdi:user-card-details-outline"
            onClick={handleClick}
            className="cursor-pointer"
          />
        </span>
      </p>
      <p title={display}>{display} </p>
    </div>
  );
};

export default SupplierInfoModal;
